import * as types from '../constants/ActionTypes'
import {actions as kandyActions} from 'kandy-redux'
import {
    agentActions,
    departmentActions,
    serviceRequestActions,
    chatActions,
    cannedMessageActions,
    getCompanyDetails,
    userRole
} from '../actions'
import {reportPreviewActions, report, serviceRequestPiccActions} from '../lossAss/actions'
import {
    agentLoggedIn,
    noticeUpdateLoginState,
    noticeUpdateServiceStatus,
    agentReconnect,
    agentConnected,
    agentDisconnected,
    serviceRequestsUpdated,
    clientEndedSession,
    removeNotificationListener,
    customerDisconnected,
    receiveUploadCarPic_Client,
    agentReconnectFailed,
    uploadShotPicFinish,
    assignedAdjustReport,
    uploadAdjustPicFinish,
    smallProgram_dropConnect_client,
    receiveEvaluationMessage,
    leaveMsgNotice,
    deflossConfirmMsg,
    receiveTxfitMsg,
    agentKandyStatus,
    agentExpired,
    getDeflossInfoSuccess,
    refreshReportDetail,
    ocrAdjustPicFinish,
    packageCrowdDataDone,
    pushTipsToAgent,
    pushCoopTaskTipsToAgent,
    trtcVideoCapture,
    AgentLocalUploadPic,
    ExpressMaterialStatUpdate,
    agentGotNewMsg,
    refreshMyTaskList,
    CallRecordVoiceDownload
} from '../socketEvents'
import {constants as kandyConstants} from 'kandy-redux'
import {isFSA} from 'flux-standard-action'
import {
    setUserAccessToken,
    removeUserAccessToken,
    removeKandyUAT,
    removeKandyPassword,
    removeKandyUserName,
    removeAgentUserType,
    setKandyUAT
} from '../utils/auth'
import t from '../localization'
import {Modal, message} from 'antd';
import EventBus from '../components/eventBus';
var notification
var notificationTimer
var notificationRequests = []
var kandyHint = null
var kandyTimer

let loginFinish = ({dispatch, getState, action}) => {

    if (!action.error && action.type === 'USER_LOGIN_FINISH') {

        let fullUserId = action.type === 'USER_LOGIN_FINISH' ? action.payload.username : action.payload.fullUserId
        if (action.payload.userAccessToken) {
            setUserAccessToken(action.payload.userAccessToken)
        }
        /* Fetch logged-in agent's details */
        dispatch(agentActions.getAgent(fullUserId)).then(() => {
            let appState = getState()
            let currentAgent = appState.app.currentAgent.userInfo

            if (!currentAgent || !currentAgent.fullUserId) {
                Modal.warning({
                    title: "错误",
                    content: t('agentNotFound')
                });
                setTimeout(function () {
                    removeUserAccessToken()
                    removeKandyUAT()
                    removeKandyPassword()
                    removeKandyUserName()
                    removeAgentUserType()
                    EventBus.emit('logout', '/login');
                }, 3000)

                return
            }

            let companyId = getState().company.id
            let agentId = currentAgent._id

            if (currentAgent.isLocked) {
                dispatch(agentActions.agentLogout(companyId, currentAgent.fullUserId))
                return
            }

            dispatch(kandyActions.login(action.payload.username, action.payload.password))
            if (currentAgent && currentAgent.agentRole && currentAgent.agentRole.menus && currentAgent.agentRole.menus.length > 0) {
                dispatch(userRole.searchRoles())
                let menus = currentAgent.agentRole.menus, redirectUrl = '';

                for (let i = 0; i < menus.length; i++) {
                    if (menus[i] === '100') {
                        redirectUrl = '/workBench';
                        break
                    } else if (menus[i] == '200') {
                        redirectUrl = '/customerCenter';
                        break
                    } else if (menus[i] == '300') {
                        redirectUrl = '/statistics';
                        break
                    } else if (menus[i] == '700') {
                        redirectUrl = '/medicalAdjustment';
                        break
                    }
                }
                if (redirectUrl) {
                    EventBus.emit('login', redirectUrl);
                }
            }

            // if (currentAgent.agentRole && currentAgent.agentRole.level == '1') {
            //     if (_.indexOf(currentAgent.permission, 'video') > -1)
            //         kandyHint = message.warning('正在登录视频通讯服务，请稍后……', 0);
            //     let kandyLogin = () => {
            //         dispatch(kandyActions.login(action.payload.username, action.payload.password))
            //         kandyTimer = setTimeout(kandyLogin, config.kandyLoginTimer)
            //     }
            //     kandyLogin()
            // }

            agentLoggedIn(fullUserId, companyId)

            /*Fetch company details */
            dispatch(getCompanyDetails.getCompanyDetails())
            /* Fetch other agents */
            dispatch(departmentActions.getDepartments(companyId))
            /* Fetch Canned Messages */
            dispatch(cannedMessageActions.getCannedMessages(companyId, agentId))
            /* Fetch other agents */
            dispatch(agentActions.getAgentList(companyId))
            /*Fetch historyReports */
            const data = {
                agentId,
                pageIndex: 1,
                pageSize: 10,
                orderBy: 'utime',
                order: 'descend',
                state: 'all',
                searchStr: '',
                channel: 'client',
                isVideoSurvey: '1',
                hasLeaveMsg:'',
                return: '', 
                majorCaseTypes:'', 
                isLostContactCsr: 0,
                flag: true
            }
            dispatch(reportPreviewActions.changeChannelType('client'))


            //dispatch(replace('dashboard'))
            /* Call socketEvent to notify server */
            agentReconnect(dispatch, Object.assign({}, departmentActions, agentActions, serviceRequestActions, reportPreviewActions), fullUserId, companyId, getState)
            agentExpired(dispatch, kandyActions, agentActions, getState)

            /* Initiate other socket events */
            noticeUpdateLoginState(dispatch, companyId, Object.assign({}, departmentActions, agentActions))
            noticeUpdateServiceStatus(dispatch, Object.assign({}, departmentActions, agentActions))
            agentConnected(dispatch, companyId, Object.assign({}, departmentActions, agentActions))
            agentDisconnected(dispatch, companyId, Object.assign({}, departmentActions, agentActions))
            serviceRequestsUpdated(dispatch, companyId, serviceRequestActions, currentAgent)
            clientEndedSession(dispatch, companyId, Object.assign({}, serviceRequestActions, chatActions, kandyActions), getState)
            customerDisconnected(dispatch, companyId, Object.assign({}, serviceRequestActions, chatActions, kandyActions, serviceRequestActions), getState)
            //get offline message
            // dispatch(kandyActions.getIm())
            receiveUploadCarPic_Client(dispatch, reportPreviewActions, agentId);
            uploadShotPicFinish(dispatch, reportPreviewActions, getState, agentId)
            agentReconnectFailed(dispatch, Object.assign({}, serviceRequestActions, serviceRequestPiccActions, reportPreviewActions), getState, fullUserId, companyId)
            assignedAdjustReport(dispatch, getState, report)
            uploadAdjustPicFinish(dispatch, getState, report)
            ocrAdjustPicFinish(dispatch, getState, report)
            packageCrowdDataDone(dispatch, getState)
            pushTipsToAgent(dispatch, getState)
            pushCoopTaskTipsToAgent(dispatch, getState)
            agentGotNewMsg(dispatch, getState)
            refreshMyTaskList(dispatch, getState)
            trtcVideoCapture(dispatch, getState)
            AgentLocalUploadPic(dispatch, getState)
            ExpressMaterialStatUpdate(dispatch, getState)
            smallProgram_dropConnect_client(getState)
            receiveEvaluationMessage(getState,dispatch)
            leaveMsgNotice(dispatch,appState)
            deflossConfirmMsg(dispatch, appState, getState)
            receiveTxfitMsg(dispatch, getState);
            getDeflossInfoSuccess(dispatch, getState)
            refreshReportDetail(dispatch, getState)
            CallRecordVoiceDownload(dispatch, getState)

            if (currentAgent.tenant) {
                window.postMessage({cmd: 'invoke', code: 'sendUserSettingToBackground(' + JSON.stringify({
                    userCode: currentAgent.thirdAccount,
                    userName: currentAgent.thirdAccountUser,
                    userPass: currentAgent.thirdAccountPass,
                    masterHost: currentAgent.tenant.claimsSystemBase,
                    picServerHost: currentAgent.tenant.imgUploadBase,
                    piccomCode: currentAgent.tenant.areaCode,
                    picserverUrl: currentAgent.tenant.imgUploadUrl,
                    uploadPicFilePath: currentAgent.tenant.imgUploadParams

                }) + ')'}, '*')
            }
        })
    } else {
        /* Remove the existing token (if any) */
        // removeKandyUAT()
    }
}

let kandyLoginFinish = ({dispatch, getState, action}) => {
    if (!action.error && action.type === '@@kandy-redux/login-finish') {

        clearTimeout(kandyTimer)
        if (kandyHint) kandyHint()
        let appState = getState()
        let currentAgent = appState.app.currentAgent.userInfo
        let companyId = appState.company.id
        setKandyUAT(action.payload.userAccessToken)
        dispatch(kandyActions.getIm())
        agentKandyStatus(dispatch, currentAgent.fullUserId, true, agentActions)
    } else if (action.error && action.type === '@@kandy-redux/login-finish') {
        /* Remove the existing token (if any) */
        // removeKandyUAT()
        // Modal.warning({
        //     title: "错误",
        //     content: 'kandy登录失败'
        // });
    }
}

/**
 * Actions called on logout.
 */
let logout = ({dispatch}) => {
    setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('userdidLogout')
    })
    clearTimeout(kandyTimer)
    if (kandyHint) kandyHint()
    removeNotificationListener()
}

let updateServiceRequests = ({dispatch, getState, action}) => {
    let appState = getState()
    let currentAgent = appState.app.currentAgent.userInfo
    let request = action.payload.data.serviceRequest;

    /*need specific agent to receive this call*/
    if (request.agent && request.agent == currentAgent._id) {
        if (action.payload.data.newRequest) {

            dispatch(serviceRequestActions.loadRequests([request]));
            notificationRequests.push(request._id)
            if (Notification.permission !== 'granted') {
                Notification.requestPermission()
            } else {
                var audio = new Audio('/audio/notification.mp3')
                let playAudio = () => {
                    audio.play()
                    clearTimeout(notificationTimer)
                    notificationTimer = setTimeout(playAudio, 5000)
                }
                playAudio()
                let carNumber = ''
                let name = ''
                if (request.userInfo) {
                    carNumber = request.userInfo.carNumber;
                    // name = request.userInfo.name || carNumber || '';
                    name = request.userInfo.flowId;
                }
                let bodyStr = name + '请求视频查勘请及时处理\n'
                let createNotification = () => {
                    notification = new Notification(t('Dashboard::newServiceRequestReceived'), {body: bodyStr, icon: '/images/notification.png'})

                    notification.onclick = () => {
                        window.focus()
                        clearTimeout(notificationTimer)
                    }

                    notification.onclose = () => {
                        clearTimeout(notificationTimer)
                    }
                }
                createNotification()
            }
        } else {

            dispatch(serviceRequestActions.loadRequests([]));
            let index = notificationRequests.indexOf(request._id)
            if (index !== -1) {
                notificationRequests.splice(index, 1)
                if (notificationRequests.length === 0 && notification) {
                    notification.close()
                    clearTimeout(notificationTimer)
                }
            }
        }
    }
}


let sessionEnded = ({dispatch, getState, action}) => {
    if (!action.error) {
        let currentCustomers = getState().app.customers.current
        let remainingSessions = currentCustomers.filter(customer => customer.userId !== action.payload.userId)
        let nextCustomerId = ''

        if (remainingSessions[0])
            nextCustomerId = remainingSessions[0]._id

        dispatch(serviceRequestActions.changeActiveCustomer(nextCustomerId))
    }
}

let cancelServiceRequests = ({dispatch, getState, action}) => {
    let index = notificationRequests.indexOf(action.payload.requestId)
    if (index !== -1) {
        notificationRequests.splice(index, 1)
        if (notificationRequests.length === 0 && notification) {
            notification.close()
            clearTimeout(notificationTimer)
        }
    }
}

let clearServiceRequests = ({dispatch, getState, action}) => {
    let selectedCustomer = getState().app.selectedCustomer
    if (selectedCustomer && notificationRequests && notificationRequests.indexOf(selectedCustomer) > -1)
        dispatch(serviceRequestActions.changeActiveCustomer(''))
    notificationRequests = []
    if (notification) {
        notification.close()
        clearTimeout(notificationTimer)
    }
    dispatch(serviceRequestActions.loadRequests([]))
}

const interceptors = {}
interceptors[kandyConstants.LOGIN_FINISH] = kandyLoginFinish
interceptors[types.USER_LOGIN_FINISH] = loginFinish
interceptors[kandyConstants.LOGOUT] = logout
interceptors[types.END_SESSION] = sessionEnded
interceptors[types.CANCEL_SERVICE_REQUEST_FINISH] = cancelServiceRequests
interceptors[types.CLEAR_SERVICE_REQUESTS] = clearServiceRequests
interceptors[types.UPDATE_SERVICE_REQUESTS] = updateServiceRequests


let middleware = ({dispatch, getState}) => {
    return next => action => {
        // Check whether the action follows Flux Standard Action
        if (isFSA(action) && interceptors[action.type]) {
            interceptors[action.type]({dispatch, getState, action})
        }

        return next(action)
    }
}

export default middleware
